var render = function render(_c,_vm){return _c('div',{staticClass:"dropdown-items"},[_c('div',{staticClass:"dropdown-items__wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }